import { FC } from 'react';

import clsx from 'clsx';
import { PackageOpen } from 'lucide-react';

import css from './EmptyPlaceholder.module.css';

import { WithClassName } from 'v2/types';

interface EmptyPlaceholderProps extends WithClassName {
  text?: string;
}
export const EmptyPlaceholder: FC<EmptyPlaceholderProps> = ({ className, text = 'There is no data to show' }) => (
  <p className={clsx(css.emptyPlaceholder, className)}>
    <PackageOpen width={18} />
    {text}
  </p>
);
